// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1CZL8","count":"styles__count___29-g2","icon":"styles__icon___1Vm-T"};